// Offline-safe numbering (DATA_MODEL.md "Numbering offline"). While online, keep at
// least MIN_REMAINING unused patient and bill numbers reserved for this device.
import type { PowerSyncDatabase } from '@powersync/web';
import { getSupabase } from '@/lib/supabase';
import { env } from '@/lib/env';
import { newId } from '@/lib/db/db';

const MIN_REMAINING = 20;
const BLOCK_SIZE = 50;

export async function ensureNumberBlocks(db: PowerSyncDatabase, clinicId: string, deviceId: string | null): Promise<void> {
  if (!env.cloud || !deviceId) return;
  for (const kind of ['patient_no', 'bill_no', 'doc_no'] as const) {
    const row = await db.getOptional<{ remaining: number }>(
      'select coalesce(sum(range_end - next_value + 1), 0) as remaining from local_numbers where clinic_id = ? and kind = ? and next_value <= range_end', [clinicId, kind]);
    if ((row?.remaining ?? 0) >= MIN_REMAINING) continue;
    const { data, error } = await getSupabase().rpc('reserve_number_block', { p_clinic: clinicId, p_kind: kind, p_device: deviceId, p_size: BLOCK_SIZE });
    if (error) { console.warn('[numbers] reserve failed', kind, error.message); continue; }
    const block = (Array.isArray(data) ? data[0] : data) as { range_start: number; range_end: number } | undefined;
    if (!block) continue;
    await db.execute('insert into local_numbers (id, clinic_id, kind, next_value, range_end) values (?, ?, ?, ?, ?)', [newId(), clinicId, kind, block.range_start, block.range_end]);
  }
}
